import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getContext } from "../../Helpers/Context/Context";
import { a11yProps } from "../../Helpers/CustomTabPanel/CustomTabPanel";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import {
  GetExportToExcelOfAllrequestOfSettlement,
  GetExportToExcelOfPendingrequestOfSettlement,
  IsSettilementRequestExist,
  SettlementExportToCSV,
} from "../../Helpers/APIEndPoints/EndPoints";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import { StyledBadge } from "../RegistrationRequest/RegistrationRequest";
import { Tooltip } from "@mui/material";
import ButtonComponent from "../../Components/ButtonForm/Button";

// import { IStatmentReqFilters } from "./Grid/IStatmentReqGrid";
import { useNavigate } from "react-router-dom";
import SettlementReqGrid from "./Grid/SettlementReqGrid";
import { SettlementRequestEnums } from "./Enums/SettlementRequestEnums";
import SettlementReqFilters from "./Filters/SettlementReqFilters";
import { ISettlementReqFilters } from "./Grid/ISettlementReqGrid";
import { ISettlementReqTabs } from "./ISettlementReqTabs";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { SettlementDashboardModules } from "../../Helpers/Enums/SettlementDashboardModules";
import { APICall } from "../../Helpers/Network/APICalls";

const SettlementRequestDashboard = () => {
  const context = getContext();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [dataCount, setDataCount] = useState(0);
  // const [pageSize] = useState(10);
  const [checkDataForSettlement, setCheckDataForSettlement] = useState(true);
  // const [sortColumn, setSortColumn] = useState("");
  // const [sortDirection, setSortDirection] = useState("");
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);
  const [currentFilters, setCurrentFilters] =
    useState<ISettlementReqFilters>(null);
  const [tabs, setTabs] = useState<ISettlementReqTabs[]>([
    {
      label: "All Requests",
      value: { ...a11yProps(0) },
      count: 0,
      active: true,
      visible: true,
      id: "All-requests",
      target: SettlementRequestEnums.AllRequest,
      module: SettlementRequestEnums.All,
    },
    {
      label: "Pending",
      value: { ...a11yProps(1) },
      count: 0,
      active: false,
      visible: true,
      id: "Pending",
      target: SettlementRequestEnums.Pending,
      module: SettlementRequestEnums.Pending,
    },
  ]);

  useEffect(() => {
    if (context.CurrentRoleId == RoleEnum.Member) {
      getIsSettilementRequestExist();
    }
  }, []);

  const changeTab = (tabNum) => {
    const newTabs = [...tabs];
    newTabs.forEach((nt) => (nt.active = false));
    newTabs[tabNum].active = true;
    setTabs(newTabs);
  };

  const ExportToExcel = async (
    url,
    fileNamePrefix,
    count,
    searchText,
    sortColumn,
    sortDirection,
    UnitCode,
    TypeOfApplicants,
    FromDate,
    ToDate,
    Status,
    start
    // activeTab,
  ) => {
    const params = {
      resultsPerPage: count,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      UnitCode: UnitCode,
      TypeOfApplicants: TypeOfApplicants,
      FromDate: FromDate,
      ToDate: ToDate,
      Status: Status,
      start: start,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: url,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `${fileNamePrefix}` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const getIsSettilementRequestExist = async () => {
    const requestData1 = {
      MemberNo: context.MemberNo,
    };

    const res = await APICall(IsSettilementRequestExist, requestData1);

    
    if (res?.Data == 0) {
      setCheckDataForSettlement(true);
    } else {
      setCheckDataForSettlement(false);
    }
  };

  const handleEvents = (target: SettlementRequestEnums, event: any = null) => {
    let activeTabs = tabs.find((t) => t.active);
    switch (target) {
      case SettlementRequestEnums.AllRequest:
        changeTab(0);
        break;
      case SettlementRequestEnums.Pending:
        changeTab(1);
        break;
      //   case StatmentRequestEnums.TabAgreementRequestClick:
      //     changeTab(2);
      //     break;
      //   case StatmentRequestEnums.TabFinalDisbursementClick:
      //     changeTab(3);
      //     break;
      case SettlementRequestEnums.FilterClick:
        setDashboardFilterOn(!dashboardFilterOn);
        break;
      case SettlementRequestEnums.SearchClick:
        setSearchText(event?.target?.value);
        break;
      case SettlementRequestEnums.ExportToExcelClick:
        if (dataCount === 0) {
          notify(ToastType.Error, "No data available");
        } else {
          let exportUrl, fileNamePrefix;
          const activeTab = tabs.find((tab) => tab.active);
          if (activeTab) {
            switch (activeTab.id) {
              case "All-requests":
                exportUrl = GetExportToExcelOfAllrequestOfSettlement;
                fileNamePrefix = "Settlement Request_";
                break;
              case "Pending":
                exportUrl = GetExportToExcelOfPendingrequestOfSettlement;
                fileNamePrefix = "PendingrequestOfSettlementReport_";
                break;
              default:
                break;
            }
          }
          if (exportUrl && fileNamePrefix) {
            ExportToExcel(
              exportUrl,
              fileNamePrefix,
              dataCount,
              currentDataReqObj.searchText,
              currentDataReqObj.sortColumn,
              currentDataReqObj.sortDirection,
              currentDataReqObj.UnitCode,
              currentDataReqObj.TypeOfApplicants,
              currentDataReqObj.FromDate,
              currentDataReqObj.ToDate,
              currentDataReqObj.Status,
              currentDataReqObj.start
            );
          }
        }
        break;
    }
  };

  const exportToCSV = async (
    UnitCodeId,
    TypeofApplicantId,
    FromDate,
    ToDate,
    Status
  ) => {
    const params = {
      MemberNos: null,
      UnitCodeId: UnitCodeId,
      TypeofApplicantId: TypeofApplicantId,
      FromDate: FromDate,
      ToDate: ToDate,
      Status: Status,
    };

    let token = await fetchAuthToken();

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: SettlementExportToCSV,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
      
        fileDownload(
          response.data,
          `SettlementReqCSV_${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.txt`
        );
      })
      .catch((error) => {
      
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const TabsComponent = ({ tab }) => {
    const { count, active, id, target, label } = tab;

    return (
      <StyledBadge
        badgeContent={count}
        color="error"
        className="mr-3"
        max={99}
        invisible={true}
      >
        <li className="nav-item" role="presentation">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            key="Dashboard"
            className={active ? "nav-link active" : "nav-link"}
            id={id}
            data-toggle="pill"
            role="tab"
            aria-controls="pills-MA"
            aria-selected={active ? "true" : "false"}
            onClick={() => handleEvents(target)}
          >
            {label}
          </a>
        </li>
      </StyledBadge>
    );
  };

  return (
    <>
      <div className="">
        <div className="">
          <div className="clearfix"></div>
          <div className="page-content row filter-row-container m-0 no-gutters">
            <div className="transformer-tabs col-lg-12 col-md-12">
              <div className="meeting-tabs tabs-main col-lg-12 p-0">
                {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0"> */}
                <div className="col-lg-12 p-0">
                  <div className="row">
                    <div className="col-lg-6 no-gutters">
                      <nav className="tabs mr-sm-4 --jsfied">
                        <ul
                          className="nav nav-pills  float-left"
                          id="pills-tab"
                          role="tablist"
                        >
                          {tabs.map((tab) => {
                            if (!tab.visible) return null;
                            return <TabsComponent tab={tab} key={tab.id} />;
                          })}
                        </ul>
                      </nav>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end no-gutters">
                      <div className="col-lg-6">
                        <div className="input-group">
                          <input
                            className="form-control py-2 border-right-0 border"
                            type="filter"
                            value={searchText}
                            placeholder="Search"
                            onChange={(e) => setSearchText(e.target.value)}
                          />
                          <span className="input-group-append">
                            <div className="input-group-text bg-transparent">
                              <i className="fa fa-search"></i>
                            </div>
                          </span>
                        </div>
                      </div>
                      <Tooltip
                        title="Filters"
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      >
                        <ButtonComponent
                          onClick={() =>
                            handleEvents(SettlementRequestEnums.FilterClick)
                          }
                          className="btn btn-submit"
                          icon={"fa fa-filter"}
                          value=""
                        />
                      </Tooltip>
                      <Tooltip
                        title={
                          tabs.find((tab) => tab.active)?.label ===
                          "All Requests"
                            ? "Export to Excel All requests"
                            : tabs.find((tab) => tab.active)?.label ===
                              "Pending"
                            ? "Export to Excel Pending requests"
                            : "Export to Excel"
                        }
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      >
                        <button
                          className="btn btn-submit"
                          onClick={() =>
                            handleEvents(
                              SettlementRequestEnums.ExportToExcelClick
                            )
                          }
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      </Tooltip>
                      {context?.CurrentRoleId === RoleEnum.InternalTeam && (
                        <Tooltip
                          title={"Export to CSV"}
                          style={{ marginLeft: "5px", cursor: "pointer" }}
                        >
                          <button
                            className="btn btn-submit"
                            onClick={() =>
                              exportToCSV(
                                currentDataReqObj.UnitCode,
                                currentDataReqObj.TypeOfApplicants,
                                currentDataReqObj.FromDate,
                                currentDataReqObj.ToDate,
                                currentDataReqObj.Status
                              )
                            }
                          >
                            <i className="fas fa-file-csv"></i>
                          </button>
                        </Tooltip>
                      )}
                      <div>
                        {checkDataForSettlement && (
                          <>
                            <ButtonComponent
                              className="btn btn-submit appl"
                              style={{
                                marginLeft: 5,
                                cursor: "pointer",
                              }}
                              icon={"fas fa-search-dollar"}
                              value={"Apply Settlement"}
                              onClick={() => {
                                navigate("/FinalSettlement", {
                                  state: {
                                    Id: 0,
                                  },
                                });
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>

          <SettlementReqFilters
            activeTab={tabs.find((t) => t.active)}
            dashboardFilterOn={dashboardFilterOn}
            setCurrentFilters={setCurrentFilters}
          />

          <SettlementReqGrid
            searchText={searchText}
            setSearchText={setSearchText}
            activeTab={tabs.find((t) => t.active)}
            currentFilters={currentFilters}
            dataCount={dataCount}
            setDataCount={setDataCount}
            setCurrentDataReqObj={setCurrentDataReqObj}
          />
        </div>
      </div>
    </>
  );
};

export default SettlementRequestDashboard;
